import API from "@/services/api";
import { 
  INoCessionSIPSSetData,
  INoCessionSIPSSucessResponse, 
  ISendNoSIPSCessionChangeParams
} from "../types/noSIPSCession";

export enum EndpointName {
  SetNoSIPSCession = '/contracts/:contractName/no_cession_sips/',
}

const sendSIPSCessionChange = ({
  contractName,
  newNoSIPSCessionSelection,
}: ISendNoSIPSCessionChangeParams) => {
  return API.post<INoCessionSIPSSucessResponse, INoCessionSIPSSetData>({
    endpoint: EndpointName.SetNoSIPSCession,
    data: {noCessionSelection: newNoSIPSCessionSelection},
    params: {
      contractName
    }
  });
}

export default {
  sendSIPSCessionChange
};